import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['header', 'messages']

    connect() {
        // Scroll events don't bubble: must attach to the actually-scrollable
        // .litigant-chat__messages, not this.element (which never scrolls).
        if (!this.hasMessagesTarget) {
            return
        }

        this.boundHandleScroll = this.handleScroll.bind(this)
        this.messagesTarget.addEventListener('scroll', this.boundHandleScroll)
    }

    disconnect() {
        if (this.boundHandleScroll && this.hasMessagesTarget) {
            this.messagesTarget.removeEventListener('scroll', this.boundHandleScroll)
        }
    }

    handleScroll() {
        if (this.messagesTarget.scrollTop > 10) {
            this.headerTarget.classList.add('scrolled')
        } else {
            this.headerTarget.classList.remove('scrolled')
        }
    }
}
